import { INavLink } from 'interfaces';

export const ROUTE_ROOT = '/';
export const ROUTE_COMPANY_RATING = 'company-rating';
export const ROUTE_JOB_PLACEMENT = 'job-placement';
export const ROUTE_BLOG = 'blog';
export const ROUTE_EMPLOYER = 'employer';
export const ROUTE_ABOUT_US = 'about-us';
export const ROUTE_ADD_RATING = 'add-rating';
export const ROUTE_PRIVACY_POLICY = 'privacy-policy';
export const ROUTE_TERMS_OF_USE = 'terms-of-use';
export const ROUTE_POSTING_GUIDELINES = 'posting-guidelines';
export const ROUTE_USER_PROFILE = 'user-profile';
export const ROUTE_ADD_COMPANY = 'add-company';
export const ROUTE_USER_ADDED_COMPANIES = 'user-added-companies';
export const ROUTE_USER_ADDED_JOB_PLACEMENTS = 'user-added-job-placements';
export const ROUTE_USER_ADDED_JOB_PLACEMENT_EDIT_GENERAL = 'user-added-job-placement-edit-general';
export const ROUTE_USER_ADDED_JOB_PLACEMENT_EDIT_CULTURE = 'user-added-job-placement-edit-culture';
export const ROUTE_USER_RATED_COMPANIES = 'user-rated-companies';

export const NAV_LINKS: INavLink[] = [
  { id: 1, link: `/${ROUTE_COMPANY_RATING}`, label: 'Company Rating' },
  { id: 2, link: `/${ROUTE_JOB_PLACEMENT}`, label: 'Job Placement' },
  { id: 3, link: `/${ROUTE_BLOG}`, label: 'Blog' },
  { id: 4, link: `/${ROUTE_EMPLOYER}`, label: 'Employer' },
];

export const USER_MENU_LINKS: INavLink[] = [
  { id: 1, link: `/${ROUTE_USER_PROFILE}`, label: 'User Profile' },
  { id: 2, link: `/${ROUTE_USER_ADDED_JOB_PLACEMENTS}`, label: 'Job Placements' },
  { id: 3, link: `/${ROUTE_USER_RATED_COMPANIES}`, label: 'Rated Companies' },
  { id: 4, link: `/${ROUTE_USER_ADDED_COMPANIES}`, label: 'Added Companies' },
];
